import React from 'react';
import { Row, Col } from "reactstrap";

const KeyboardShortcuts = () => {
    return (
      <div className="shortcuts">
      <h6 className="pl-3 text-capitalize text-center">Keyboard Shortcuts</h6>
      <Row>
          <div className="sub-div">
            <Col xs={12}>
              <ul className="text-left">
                <li className="mb-2"><span><code>Shift + Enter</code></span> <span className="text-muted">-&nbsp; &nbsp;  Run the current cell, select below</span></li>
                <li className="mb-2"><span><code>Ctrl + Enter</code></span> <span className="text-muted">-&nbsp; &nbsp;  Run selected cells</span></li>
                <li className="mb-2"><span><code>{navigator.appVersion.indexOf("Mac") !== -1 ? "Option" : "Alt"} + Enter</code></span> <span className="text-muted">-&nbsp; &nbsp;  Run the current cell, insert below</span></li>
                <li className="mb-2"><span><code>Ctrl + Shift + S</code></span> <span className="text-muted">-&nbsp; &nbsp;  Save and checkpoint</span></li>
              </ul>
            </Col>
          </div>
      </Row>
    </div>
    )
  }

  export default KeyboardShortcuts;

